import { popoverLegacyDriverFactory } from '../../Popover/Popover.driver';

export const closablePopoverDriverFactory = ({ element, eventTrigger }) => {
  const popoverDriver = popoverLegacyDriverFactory({ element, eventTrigger });

  return {
    ...popoverDriver,
    /** Checks if the popover's content is open */
    isOpened: () => popoverDriver.isContentElementExists(),
  };
};
